try {
  var scriptElement = document.createElement("script");
  var sourceUrl = "https://sdk.breeze.in/electron/251.0.1/index.js";
  scriptElement.setAttribute("src", sourceUrl);
  scriptElement.setAttribute("type", "module");
  scriptElement.setAttribute("id", "breeze-script-tag");
  scriptElement.setAttribute("data-environment", "release");
  scriptElement.setAttribute("data-platform", "shopify");
  scriptElement.setAttribute("data-enable-external-trackers", "true");
  scriptElement.setAttribute("data-enable-snap-tracker", "true");
  scriptElement.setAttribute("data-enable-ga", "true");
  scriptElement.setAttribute("data-enable-fbp", "true");
  scriptElement.setAttribute("data-emit-tracker-events", "true");
  scriptElement.setAttribute("data-ga4-measurement-id", "G-5KY19YPRS");
  scriptElement.setAttribute("data-merchantid", "veganday");
  scriptElement.setAttribute("data-ga-version", "new");
  scriptElement.setAttribute("data-app-version", "v2");
  scriptElement.setAttribute("ghost-mode", "false");
 document.head.append(scriptElement);
    var cdpScript = document.createElement("script");
    cdpScript.setAttribute("src", "https://sdk.breeze.in/cdp/251.0.1/index.js");
    document.head.append(cdpScript);
} catch (e) {
  console.log("Something went wrong");
}
window.bzGhostMode = false;
window.addToCartSelector = "";
window.buyNowSelector = "";
window.checkoutSelector = "";
